"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubspotConversionTouchPointDialogBase = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_use_hubspot_form_1 = require("@aaronhayes/react-use-hubspot-form");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var Button_1 = require("../Button");
/**
 * @internal
 */
exports.HubspotConversionTouchPointDialogBase = function (props) {
    var targetId = props.targetId, hubspotPortalId = props.hubspotPortalId, hubspotFormId = props.hubspotFormId, selectedValue = props.selectedValue, cancelButtonText = props.cancelButtonText, dialogTitle = props.dialogTitle, showCancelButton = props.showCancelButton, submitButtonClass = props.submitButtonClass, _a = props.values, values = _a === void 0 ? {} : _a, onClose = props.onClose, onFormSubmitted = props.onFormSubmitted;
    var intl = react_intl_1.useIntl();
    var _b = tslib_1.__read(react_1.useState(false), 2), isFormReady = _b[0], setIsFormReady = _b[1];
    var hubspotFormTargetId = targetId || "conversion-touch-point-hubspot";
    react_1.useEffect(function () {
        var _a;
        // the Hubspot form requires jQuery object, we need to create a fake jQuery object to bypass this.
        window.jQuery =
            window.jQuery ||
                function (nodeOrSelector) {
                    if (typeof nodeOrSelector == "string") {
                        return document.querySelector(nodeOrSelector);
                    }
                    return nodeOrSelector;
                };
        if ((_a = window.hbspt) === null || _a === void 0 ? void 0 : _a.isSuccessMessageShow) {
            window.hbspt.isSuccessMessageShow = false;
        }
    }, []);
    var onHubspotFormSubmitted = function () {
        if (!window.hbspt.isSuccessMessageShow) {
            onFormSubmitted === null || onFormSubmitted === void 0 ? void 0 : onFormSubmitted();
            onClose();
            window.hbspt.isSuccessMessageShow = true;
        }
    };
    var formCreated = react_use_hubspot_form_1.useHubspotForm({
        portalId: hubspotPortalId,
        formId: hubspotFormId,
        target: "#" + hubspotFormTargetId,
        locale: intl.locale.split("-").shift(),
        submitButtonClass: submitButtonClass,
        onFormSubmitted: onHubspotFormSubmitted,
        onFormReady: function ($form) {
            var _a;
            setIsFormReady(true);
            var fields = $form;
            if (fields["jquery"] && ((_a = fields[0]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                fields = fields[0];
            }
            // populating the values for hidden fields
            for (var i = 0; i < fields.length; i += 1) {
                var inputField = fields[i];
                if (!inputField) {
                    continue;
                }
                var populatedValue = values[inputField.name];
                if (populatedValue) {
                    inputField.value = populatedValue;
                }
                if (selectedValue && inputField.value.indexOf(selectedValue) !== -1) {
                    // Call click event to check the radio button on Hubspot form
                    inputField.click();
                }
            }
        },
    }).formCreated;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !formCreated && react_1.default.createElement(sdk_ui_1.LoadingComponent, null),
        formCreated && (react_1.default.createElement("div", { className: "conversion-touch-point-dialog-wrapper" },
            isFormReady && dialogTitle && react_1.default.createElement("h3", null, dialogTitle),
            react_1.default.createElement("div", { id: hubspotFormTargetId, className: "hubspot-form" }),
            isFormReady && showCancelButton && (react_1.default.createElement(Button_1.Button, { className: "gd-button-secondary", onClick: onClose, value: cancelButtonText }))))));
};
//# sourceMappingURL=HubspotConversionTouchPointDialogBase.js.map